/* Lead-source tracking: capture UTM / landing context once per session,
   and expose hidden fields for lead-form submissions. */

const KEY = "lb_lead_ctx";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

const readCtx = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
};

const writeCtx = (ctx) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(ctx));
  } catch {
    /* storage unavailable — non-fatal */
  }
};

/** Call once on app load: persist first-touch UTM + landing context. */
export const initTracking = () => {
  const existing = readCtx();
  if (existing.captured) return;
  const params = new URLSearchParams(window.location.search);
  const ctx = { captured: true, landing_page: window.location.href, referrer: document.referrer || "" };
  UTM_KEYS.forEach((k) => {
    ctx[k] = params.get(k) || "";
  });
  writeCtx(ctx);
};

/** Hidden lead fields merged into every enquiry/proposal submission. */
export const getTracking = (formRenderedAt) => {
  const ctx = readCtx();
  return {
    utm_source: ctx.utm_source || "",
    utm_medium: ctx.utm_medium || "",
    utm_campaign: ctx.utm_campaign || "",
    utm_content: ctx.utm_content || "",
    utm_term: ctx.utm_term || "",
    landing_page: ctx.landing_page || "",
    referrer: ctx.referrer || "",
    page: window.location.href,
    form_rendered_at: formRenderedAt,
  };
};

/** Fire the lead conversion event ONLY after a genuinely successful submission. */
export const fireGenerateLead = (reference, kind) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "generate_lead", lead_reference: reference, lead_kind: kind });
  } catch {
    /* analytics not present — non-fatal */
  }
};
